import { render } from "./NegociosAliados.vue?vue&type=template&id=320eb476&scoped=true"
import script from "./NegociosAliados.vue?vue&type=script&lang=js"
export * from "./NegociosAliados.vue?vue&type=script&lang=js"

import "./NegociosAliados.vue?vue&type=style&index=0&id=320eb476&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320eb476"]])

export default __exports__